var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property"},[_c('h1',[_vm._v(_vm._s(_vm.$t('integration.attribute_list')))]),_c('Attribute',{attrs:{"isShowEdit2":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }